import { Button } from "@material-ui/core";
import { Box, Modal, TextField, Typography } from "@mui/material";
import { MagnifyingGlass, UserPlus } from "phosphor-react";
import { useEffect, useState } from "react";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { fget } from "../../API/callsAPI";
import myTeamsPageStyles from "../MyTeamPageComponents/MyTeamsPageStyles";
import InviteUserModal from "../ProjectPage/ProjectPageModals/InviteUserModal/InviteUserModal";
import CustomPagination from "../Utilities/CustomPagination/CustomPagination.component";
import Loader from "../Utilities/Loader/Loader";
import LeaveTeamModal from "./LeaveTeamModal";
import MyTeamCollaboratorsTable from "./MyTeamCollaboratorsTable";

const MyTeamMembersPageOverview = ({ setSnackValue }) => {
  const { id } = useParams();
  const classes = myTeamsPageStyles();
  const history = useHistory();
  const [nameSearchQuery, setNameSearchQuery] = useState("");
  const [isInviteUsersModalOpen, setIsInviteUsersModalOpen] = useState(false);
  const [isLeaveTeamModalOpen, setIsLeaveTeamModalOpen] = useState(false);
  const [teamDetails, setTeamDetails] = useState();
  const [isTeamDetailsLoaded, setIsTeamDetailsLoaded] = useState(false);
  const [refreshCounter, setRefreshCounter] = useState(0);
  const [isUsersLoading, setIsUsersLoading] = useState(true);
  const [teamUsers, setTeamUsers] = useState({});
  const [currentPage, setCurrentPage] = useState(1);

  // Get team details
  useEffect(() => {
    const handleGetTeamDetails = async () => {
      try {
        setIsTeamDetailsLoaded(false);
        const res = await fget({ url: `project-space/${id}` });
        setTeamDetails(res?.data);
        setIsTeamDetailsLoaded(true);
      } catch (error) {
        console.log(error);
      }
    };
    handleGetTeamDetails();
  }, [refreshCounter, id]);

  // ✅ Debounced Search Effect
  useEffect(() => {
    const handler = setTimeout(async () => {
      try {
        setIsUsersLoading(true);

        // ✅ If search is empty, fetch default users
        if (!nameSearchQuery.trim()) {
          const res = await fget({
            url: `project-space/${id}/users?page=${currentPage}`,
          });
          setTeamUsers(res?.data);
          setIsUsersLoading(false);
          return;
        }

        // ✅ Minimum characters
        if (nameSearchQuery.length < 2) {
          setIsUsersLoading(false);
          return;
        }

        // ✅ Debounced API call
        const res = await fget({
          url: `project-space/${id}/users?page=${currentPage}&q=${nameSearchQuery}`,
        });
        setTeamUsers(res?.data);
        setIsUsersLoading(false);
      } catch (error) {
        console.log(error);
      }
    }, 300);

    return () => clearTimeout(handler);
  }, [refreshCounter, id, nameSearchQuery]);
  return (
    <>
      {isTeamDetailsLoaded ? (
        <Box style={{ width: "100%", height: "100%" }}>
          <Box
            className={classes.teamDetailsRightSideTop}
            style={{ marginBottom: "8px" }}
          >
            <Box className={classes.teamDetailsRightSideTopSingleItem}>
              <Typography sx={{ color: "#606479" }}>Plan</Typography>
              <Typography sx={{ color: "#F9F9F9" }}>
                {teamDetails?.tier}
              </Typography>
            </Box>
            <Box className={classes.teamDetailsRightSideTopSingleItem}>
              <Typography sx={{ color: "#606479" }}>Created On</Typography>
              <Typography sx={{ color: "#F9F9F9" }}>
                {teamDetails?.created_at &&
                  new Intl.DateTimeFormat("en-US", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  }).format(new Date(teamDetails?.created_at ?? ""))}
              </Typography>
            </Box>
            <Box className={classes.teamDetailsRightSideTopSingleItem}>
              <Typography sx={{ color: "#606479" }}>Admin</Typography>
              <Typography sx={{ color: "#F9F9F9" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <div className={classes.userNameAvatar}>
                    {teamDetails?.admin?.first_name?.charAt(0).toUpperCase() ??
                      ""}
                    {teamDetails?.admin?.last_name?.charAt(0).toUpperCase() ??
                      ""}
                  </div>{" "}
                  {teamDetails?.admin?.first_name}{" "}
                  {teamDetails?.admin?.last_name}
                </div>
              </Typography>
            </Box>
            <Box className={classes.teamDetailsRightSideTopSingleItem}>
              <Typography sx={{ color: "#606479" }}>Projects</Typography>
              <Typography sx={{ color: "#F9F9F9" }}>0</Typography>
            </Box>
            <Box className={classes.teamDetailsRightSideTopSingleItem}>
              <Typography sx={{ color: "#606479" }}>Members</Typography>
              <Typography sx={{ color: "#F9F9F9" }}>
                {teamDetails?.collaborators?.length ?? 0}
              </Typography>
            </Box>
          </Box>
          <Box
            className={classes.header}
            style={{ margin: "16px 0px !important" }}
          >
            <Typography sx={{ color: "#F9F9F9", fontSize: "20px" }}>
              Members{" "}
              <span
                style={{
                  color: "#6C65D9",
                  marginLeft: "10px",
                }}
              >
                {teamDetails?.collaborators?.length || 0}
              </span>
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <Button
                className={classes.backButton}
                startIcon={<UserPlus />}
                onClick={() => setIsInviteUsersModalOpen(true)}
              >
                Invite
              </Button>

              <div className={classes.searchBoxContainer}>
                <MagnifyingGlass size={20} color="#606479" />
                <TextField
                  inputProps={{
                    style: {
                      color: "#606479 !important",
                    },
                  }}
                  sx={{
                    paddingLeft: "4px",
                    "& .MuiInputBase-input": {
                      color: "#fff !important",
                    },
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        border: "none",
                      },
                    },
                    "& .MuiInputBase-input": {
                      padding: "8px 0px",
                      color: "#606479",
                    },
                  }}
                  size="small"
                  fullWidth
                  placeholder="Search in list"
                  onChange={(e) => setNameSearchQuery(e.target.value)}
                  value={nameSearchQuery}
                />
              </div>
            </Box>
          </Box>

          <Box sx={{ height: "75%" }}>
            {!isUsersLoading ? (
              <MyTeamCollaboratorsTable
                teamDetails={{
                  ...teamDetails,
                  collaborators: teamUsers?.results,
                }}
                setRefreshCounter={() => setRefreshCounter(refreshCounter + 1)}
                setSnackValue={setSnackValue}
              />
            ) : (
              <Loader />
            )}
          </Box>
          {isTeamDetailsLoaded ? (
            <CustomPagination
              handlePageChange={(e) => setCurrentPage(e)}
              currentPage={currentPage}
              totalItem={teamUsers?.count}
              totalPage={Math.ceil(teamUsers?.count / 50)}
              setIsNewPageLoading={false}
              trackable="Team Members"
              isExternalReviewer={false}
              isTeamsPage={true}
            />
          ) : (
            ""
          )}
        </Box>
      ) : (
        <Loader />
      )}
      <Modal open={isLeaveTeamModalOpen} className={classes.flexCenter}>
        <LeaveTeamModal
          handleClose={() => setIsLeaveTeamModalOpen(false)}
          teamDetails={teamDetails}
          handleRefresh={() => {
            setRefreshCounter(refreshCounter + 1);
            history.push("/my-teams");
          }}
          setSnackValue={setSnackValue}
          userType="team"
        />
      </Modal>

      <Modal
        open={isInviteUsersModalOpen}
        onClose={() => setIsInviteUsersModalOpen(false)}
        className={classes.flexCenter}
      >
        <InviteUserModal
          inviteType="team"
          teamId={id}
          handleRefresh={() => {
            setRefreshCounter(refreshCounter + 1);
            setIsInviteUsersModalOpen(false);
          }}
          setSnackValue={setSnackValue}
        />
      </Modal>
    </>
  );
};

export default MyTeamMembersPageOverview;
